module.exports = __webpack_public_path__ + "static/header-093210fefd1884f9beda35894fa6cc36.svg";